import {Outlet} from 'react-router'
/**
 * Ovid layout shell. Renders only the fixed film-grain overlay + the route outlet; the maison
 * header AND footer are rendered per-route, so each surface controls its own header variant and
 * active-nav state — unlike narcis, whose own `_layout.tsx` renders `<Footer/>` once here and
 * leaves only the header to each route.
 */
export default function Layout() {
    return (
        <>
            <div className="ov-grain" />
            <Outlet />
        </>
    )
}
